import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Injector,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Placement } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { RadioButtonModel } from '../../models/radio-button.model';
import { AbstractValueAccessor, MakeProvider } from '../abstract-value-accessor';

@Component({
  selector: 'app-radio-button-group',
  templateUrl: './radio-button-group.component.html',
  styleUrls: ['./radio-button-group.component.scss'],
  providers: [MakeProvider(RadioButtonGroupComponent)],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RadioButtonGroupComponent extends AbstractValueAccessor implements AfterViewInit, OnChanges, OnInit {
  errorTexts: { [key: string]: string | (() => string) };
  index: number;
  validateOnDirty: boolean;
  formGroup: UntypedFormGroup;

  @Input()
  required: boolean;

  @Input()
  hideButton: boolean;

  @Input()
  label: string;

  @Input()
  labelWithColon = true;

  @Input()
  isLabelBold = true;

  @Input()
  sublabel: string;

  @Input()
  infoTooltip: string | TemplateRef<any>;

  @Input()
  infoTooltipPlacement: Placement;

  @Input()
  infoTooltipClass: string;

  @Input()
  buttonTooltipSelected: string;

  @Input()
  buttonTooltip: TemplateRef<any> | string;

  @Input()
  buttonTooltipPlacement: Placement;

  @Input()
  buttonTooltipClass = 'default-tooltip';

  @Input()
  labelParamsObj: any;

  @Input()
  buttons: RadioButtonModel[];

  @Input()
  selectFirst?: boolean;

  @Input()
  noteTranslationKey: () => string;

  @Input()
  dynamicNoteFactory: (value: any) => TemplateRef<any>;

  @Input()
  extendedMode = false;

  @Input()
  buttonsPosition: 'vertical' | 'horizontal' = 'horizontal';

  @Input()
  buttonsSize: 13 | 18 = 18;

  @Input()
  customGap: 'default' | '16px' = 'default';

  constructor(
    private translateService: TranslateService,
    private cd: ChangeDetectorRef,
    injector: Injector,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnChanges(simpleChanges: SimpleChanges): void {
    super.ngOnChanges(simpleChanges);
  }


  ngAfterViewInit(): void {
    if (this.selectFirst) {
      this.setValue(0);
    }
  }

  isRadioButtonDisabled(btn: RadioButtonModel): boolean {
    return this.isDisabled || btn?.comingSoon || btn?.disabled;
  }

  setValue(buttonIndex: number): void {
    if (this.buttons[buttonIndex].disabled) {
      return;
    }

    this.value = this.buttons[buttonIndex].value;
    this.cd.detectChanges();
  }

  checkValue(rbtn: RadioButtonModel): boolean {
    return this.value == rbtn.value;
  }

  getButtonLabelAsTemplate(rbLabel: RadioButtonModel): TemplateRef<any> {
    return rbLabel.label as TemplateRef<any>;
  }

  getButtonTooltip(rbLabel: RadioButtonModel): string | TemplateRef<any> {
    if (rbLabel.disabled && rbLabel.disabledReasonTranslationKey) {
      return this.translateService.instant(rbLabel.disabledReasonTranslationKey);
    }

    return this.buttonTooltipSelected === rbLabel.value
      ? this.buttonTooltip
      : rbLabel.tooltipTranslation && !this.isDisabled
        ? this.translateService.instant(rbLabel.tooltipTranslation)
        : '';
  }

  isButtonLableTemplate(rbLabel: string | TemplateRef<any>): boolean {
    return !(typeof rbLabel === 'string');
  }
}
